import zhLocale from '../components/locale/lang/zh-CN';
import enLocale from '../components/locale/lang/en-US';
import twLocale from '../components/locale/lang/zh-TW';
var lang = localStorage.getItem('lang'),
locale;
if(lang == 'zh-CN' || lang == null){
	locale = zhLocale;
}else if(lang == 'zh-TW'){
	locale = twLocale
}else if(lang == 'en-US'){
	locale = enLocale
}

export default locale




// WEBPACK FOOTER //
// ./src/api/menuLanguage.js